<template>
  <div id="list">
    <div id="serch">
      <ul>
        <li>
          <span style="width:80px">公司名称：</span>
          <el-input v-model="serch.公司名称" size="mini" @keyup.enter.native="toserch"></el-input>
        </li>
        <li>
          <span>公司类型：</span>
          <el-select v-model="serch.公司类型" placeholder="请选择" filterable multiple size="mini">
            <el-option v-for="item in type" :key="item" :value="item"></el-option>
          </el-select>
        </li>
        <li>
          <span>是否签约：</span>
          <el-select v-model="serch.签约" placeholder="请选择" size="mini">
            <el-option v-for="item in sign" :key="item" :value="item"></el-option>
          </el-select>
        </li>
        <li>
          <span>行业：</span>
          <el-select v-model="serch.行业" filterable multiple placeholder="请选择" size="mini">
            <el-option v-for="item in industry" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </li>
        <li>
          <span style="width:60px">办公地：</span>
          <el-select v-model="serch.办公地" filterable multiple placeholder="请选择" size="mini">
            <el-option v-for="item in baseadress" :key="item" multiple :label="item" :value="item"></el-option>
          </el-select>
        </li>
        <li>
          <span>公司性质：</span>
          <el-select v-model="serch.公司性质" placeholder="请选择" filterable multiple size="mini">
            <el-option v-for="item in companyNature" :key="item" :value="item"></el-option>
          </el-select>
        </li>
        <li>
          <span>平台等级：</span>
          <el-select v-model="serch.平台等级" placeholder="请选择" multiple size="mini">
            <el-option v-for="item in ['A', 'B', 'C']" :key="item" :value="item"></el-option>
          </el-select>
        </li>
        <li>
          <span>香港牌照：</span>
          <el-select v-model="serch.香港牌照" placeholder="请选择" filterable multiple size="mini">
            <el-option v-for="item in qualification" :key="item" :value="item"></el-option>
          </el-select>
        </li>
        <li style="max-width:496px">
          <span style="width:60px">签约时间：</span>
          <el-date-picker
            v-model="gttime"
            style="width:180px"
            type="date"
            placeholder="选择日期"
            size="mini"
          ></el-date-picker
          >--
          <el-date-picker
            v-model="lttime"
            style="width:180px"
            type="date"
            placeholder="选择日期"
            size="mini"
          ></el-date-picker>
        </li>
        <li>
          <div class="radish-btn radish-btn-primary radish-btn-small" @click="toserch">搜索</div>
          <div class="radish-btn radish-btn-primary radish-btn-small" style="margin-left: 10px;" @click="clearSerch">
            清空
          </div>
        </li>
      </ul>
    </div>
    <div id="listbox">
      <div
        class="radish-act-grp"
        style="display: inline-flex;align-items: center;background-color:#fff;padding-left: 0;"
        @click.stop
      >
        <span class="label" style="width:60px">展现形式：</span>
        <div
          v-for="v in ['列表模式', '详情模式']"
          :key="v"
          class="radish-search-tag"
          :class="{ 'radish-search-tag-active': tableType === v }"
          @click="changeTableType(v)"
        >
          {{ v }}
        </div>
      </div>
      <div class="radish-btn radish-btn-primary radish-btn-small" style="margin: 0 10px 10px;" @click="insertcompany">
        新增公司
      </div>
      <div class="radish-btn radish-btn-primary radish-btn-small" style="margin: 0 10px 10px;" @click="gotozhaopin">
        招聘信息汇总统计
      </div>
      <el-table
        ref="multipleTable"
        v-loading="tableloading"
        :data="list"
        border
        :height="listheight"
        tooltip-eff0-ect="dark"
        size="mini"
        style="width: 100%"
        @sort-change="sortChange"
      >
        <!-- <el-table-column type="selection" width="40"></el-table-column> -->
        <el-table-column label="操作" align="center" width="45">
          <template slot-scope="scope">
            <a :id="`h${scope.row._id}`" class="popper-btn" @click="showDropdown(scope.row, `h${scope.row._id}`)">
              <i class="el-icon-setting" />
            </a>
          </template>
        </el-table-column>
        <el-table-column label="附件" width="60">
          <template slot-scope="scope">
            <el-popover v-if="scope.row.附件.length > 0" placement="right" width="700" trigger="click">
              <FileTable
                :files="scope.row['附件']"
                :paginate="false"
                width="600"
                :show-download="isadmin"
                height="300"
              />
              <el-button slot="reference" type="text" icon="el-icon-view">{{ scope.row.附件.length }}</el-button>
            </el-popover>
            <div v-else-if="scope.row.附件.length === 0" style="display: flex;align-items: baseline;">
              <i class="el-icon-document"></i> <span>0</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="公司名称" label="公司名称" width="190">
          <template slot-scope="scope">
            <a class="company-pointer" :href="`#/company/${scope.row._id}`" target="_blank">{{ scope.row.公司名称 }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="行业" label="行业" width="80"></el-table-column>
        <el-table-column prop="平台等级" label="平台等级" width="140">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.平台等级"
              placeholder="请选择"
              size="mini"
              @change="updatecompany(scope.row._id, scope.row.平台等级, '平台等级')"
            >
              <el-option v-for="item in ['A', 'B', 'C']" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="排名" label="排名" width="80" sortable="custom"></el-table-column>
        <el-table-column prop="公司性质" label="公司性质" width="140">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.公司性质"
              placeholder="请选择"
              filterable
              size="mini"
              @change="updatecompany(scope.row._id, scope.row.公司性质, '公司性质')"
            >
              <el-option v-for="item in companyNature" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="公司性质（批注）" label="公司性质（批注）" width="140"></el-table-column>
        <el-table-column prop="总部所在地" label="总部所在地" width="140"></el-table-column>
        <el-table-column prop="办公地" label="办公地" width="220">
          <template slot-scope="scope">
            <el-tag
              v-for="(item, index) in scope.row.办公地"
              :key="index + 2"
              type="success"
              size="mini"
              style="text-align:center"
              >{{ item }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="注册地" label="注册地" width="220"></el-table-column>
        <el-table-column prop="签约时间" label="签约时间" width="120" sortable="custom"></el-table-column>
        <el-table-column label="类型" width="85">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.公司类型 == '重点客户'" type="danger" size="mini" style="text-align:center"
              >重点客户</el-tag
            >
            <el-tag v-else-if="scope.row.公司类型 == '客户公司'" type="warning" size="mini" style="text-align:center"
              >客户公司</el-tag
            >
            <el-tag v-else-if="scope.row.公司类型 == '目标客户'" type="success" size="mini" style="text-align:center"
              >目标客户</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="状态" width="70">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.签约 == '已签约'" type="success" size="mini">已签约</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="项目数" label="项目数" width="120"></el-table-column>
        <el-table-column prop="成功项目" label="成功项目" width="120"></el-table-column>
        <el-table-column prop="进展中" label="进展中" width="120"></el-table-column>
      </el-table>
      <el-pagination
        class="company-pagination"
        background
        :current-page="page"
        :page-sizes="[20, 70, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>

      <Popper
        :visible.sync="popperVisible"
        :target-id="popperTarget"
        container="projectTableWrapper"
        class-name="shadow"
      >
        <div class="dropdown-popper">
          <div v-if="showDeskfollowBtn()" class="item" @click="deleteDesktopFollow">工作台取消关注</div>
          <div v-else class="item" @click="addDesktopFollow">工作台关注</div>
        </div>
      </Popper>
    </div>
  </div>
</template>
<script>
import { FileTable } from '../../file'
import Popper from '../../project/src/components/Popper'
import * as fixedvariant from '../statistics/variant/fixedvariant'

import '@c42/vue-orgchart/lib/orgchart.css'

export default {
  components: { FileTable, Popper },
  data() {
    return {
      gttime: '',
      lttime: '',
      tableloading: false,
      listheight: '100px',
      companytype: '',
      companyName: '',
      page: 1,
      total: 0,
      pageSize: 20,
      detail: false,
      list: [],
      restaurants: [],
      sign: ['已签约', '项目拟客户', '跟进中'],
      type: ['重点客户', '客户公司', '目标客户', '暂不合作'],
      companyNature: fixedvariant.公司性质,
      query: { query: {} },
      sort: { 排名: 1 },
      serch: {
        公司名称: '',
        签约: '',
        公司类型: [],
        行业: [],
        办公地: [],
        公司性质: [],
        香港牌照: [],
        平台等级: [],
      },
      industry: app.industries || [],
      baseadress: fixedvariant.工作地点,
      qualification: JSON.parse(JSON.stringify(fixedvariant.香港牌照)),
      popperVisible: false,
      popperTarget: '',
      tableType: '列表模式',
    }
  },
  computed: {
    isadmin() {
      return app.user.角色 && app.user.角色.includes('管理员')
    },
  },
  created() {
    this.listheight = `${window.innerHeight - 260}px`
  },
  mounted: async function() {
    const query = this.$route.query
    if (query.industry) {
      this.query.query.行业 = query.industry
    } else if (query.platform) {
      this.query.query.平台等级 = query.platform
    }
    this.getlist()
  },
  methods: {
    changeTableType(v) {
      if (v === '列表模式') this.$router.push('/companylist')
      else this.$router.push('/NewCompanyList')
    },
    showDeskfollowBtn() {
      if (!this.company) return false
      const { desktopFollow = [] } = this.company
      const account = app.user.account
      const hasFollow = desktopFollow.find(val => val.account === account && val.type === 'company')
      return !!hasFollow
    },
    showDropdown(row, targetId) {
      this.company = row
      this.popperVisible = true
      this.popperTarget = targetId
    },
    insertcompany() {
      window.open(`${window.origin}/#/NewAddCompany`, '_blank')
    },
    async updatecompany(id, value, field) {
      const res = await app.service('company').modifyCompany({
        query: { _id: id },
        data: { [field]: value },
      })
      if (res.status === 200 || res.status === 'success') this.$message('修改成功')
      else this.$message(res.msg)
    },
    sortChange(data) {
      const sortProp = ['排名', '签约时间']
      for (const type of sortProp) {
        if (data.prop !== type) continue
        if (data.order === 'ascending' || data.order == null) {
          this.sort[type] = 1
        } else if (data.order === 'descending') {
          this.sort[type] = -1
        }
        this.getlist()
        break
      }
    },
    handleCurrentChange(val) {
      this.page = val
      this.getlist()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getlist()
    },
    // handleSelectionChange(val) {
    //   this.multipleSelection = val
    // },
    // showdetail(val) {
    //   app.root.$refs.fullCompany.open(val._id, 'id')
    // },
    trim(val) {
      return val.replace(/(^\s*)|(\s*$)/g, '')
    },
    toserch() {
      const option = {}
      for (const key in this.serch) {
        const val = this.serch[key]
        if (typeof val === 'string') {
          if (val !== '') {
            option[key] = this.trim(val)
          }
        } else {
          option[key] = val
        }
      }
      this.query.query = option
      const obj = { time: { gttime: this.gttime, lttime: this.lttime } }
      this.getlist(obj)
    },
    clearSerch() {
      for (const key in this.serch) {
        const val = this.serch[key]
        this.serch[key] = Array.isArray(val) ? [] : ''
      }
      this.query.query = {}
      this.gttime = ''
      this.lttime = ''
      this.page = 1
      this.getlist()
    },
    async getlist(time) {
      const query = Object.assign(
        this.query,
        {
          paginate: {
            page: this.page,
            pageSize: this.pageSize,
            sort: this.sort,
          },
        },
        time,
      )
      await app
        .service('project')
        .saveRecords({ type: '公司搜索', path: '公司列表-列表模式', page: '公司', data: { 搜索条件: query } })
      try {
        this.tableloading = true
        const { data, page, pageSize, total } = await window.app.service('company').getCompanyList(query)
        this.tableloading = false
        this.list = data
        this.page !== page && (this.page = page)
        this.pageSize !== pageSize && (this.pageSize = pageSize)
        this.total !== total && (this.total = total)
      } catch (error) {
        this.$message(error.message)
      }
    },
    async addDesktopFollow() {
      const res = await app
        .service('company')
        .addDesktopFollow({ type: 'company', bindId: this.company._id, account: app.user.account })
      if (res.status === 'success') {
        this.company.desktopFollow = res.data
        this.$message.success('关注成功')
      } else this.$message.error(res.msg)
      this.popperVisible = false
    },
    async deleteDesktopFollow() {
      const res = await app
        .service('company')
        .deleteDesktopFollow({ type: 'company', bindId: this.company._id, account: app.user.account })
      if (res.status === 'success') {
        this.$message.success('取消关注成功')
        this.company.desktopFollow = []
      } else this.$message.error(res.msg)
      this.popperVisible = false
    },
    gotozhaopin() {
      window.open(`${window.origin}/#/companyZhaopin`)
    },
  },
}
</script>
<style src="../statistics/css/companyList.css" scoped></style>
